import React, { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { ArrowUp } from "lucide-react";

// Small global affordance: appears once the visitor has scrolled a page's
// worth down, scrolls smoothly back to the top on click. Frontend-only,
// no data/backend involvement — mounted once in the app shell so it's
// available on every route without each page needing to add it.
//
// DESKTOP ONLY (owner, 2026-08). On a phone it sat at bottom-6, which is
// behind the 65px bottom bar — invisible and untappable — and on a collective
// it would have collided with the composer FAB as well. Rather than shuffle it
// up past two pieces of fixed furniture, it goes: a thumb-flick to the top is
// already the fastest thing on a touchscreen, and the button only ever earned
// its place on a device with no such gesture.
export function BackToTop() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          onClick={scrollToTop}
          aria-label="Back to top"
          data-testid="back-to-top-btn"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: reduceMotion ? 0 : 0.2 }}
          className="hidden lg:flex fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-forest text-white shadow-lg shadow-forest/20 items-center justify-center hover:bg-forest-hover transition-colors"
        >
          <ArrowUp className="w-5 h-5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
